// ABOUTME: Router component for premium-market space with dedicated MSAL configuration
// ABOUTME: Handles routing and authentication for premium market features
import { Routes, Route, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";

// MSAL imports
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "../utils/NavigationClient";

// Sample app imports
import { PageLayout } from "../ui-components/PageLayout";
import { Home } from "../pages/Home";
import { Profile } from "../pages/Profile";

type PremiumMarketRouterProps = {
    pca: IPublicClientApplication;
};

export function PremiumMarketRouter({ pca }: PremiumMarketRouterProps) {
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);

    return (
        <MsalProvider instance={pca}>
            <PageLayout>
                <Grid container justifyContent="center">
                    <Routes>
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/" element={<Home />} />
                    </Routes>
                </Grid>
            </PageLayout>
        </MsalProvider>
    );
}
